import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = ({ onNavigate, currentPage = 'home', theme = 'light' }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavigation = (page) => {
    if (onNavigate) {
      onNavigate(page);
    }
    setIsMenuOpen(false);
  };

  const navItems = [
    { id: 'digital-school', label: 'Digital School' },
    { id: 'overseas', label: 'Study Abroad' },
    { id: 'scratch-cards', label: 'Scratch Cards' },
    { id: 'exam-prep', label: 'Exam Prep' }
  ];

  const isActive = (pageId) => currentPage === pageId;

  return (
    <nav className="sticky top-0 z-50 w-full bg-white border-b border-gray-200 backdrop-blur-sm bg-white/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <button
              onClick={() => handleNavigation('home')}
              className="flex items-center space-x-3"
            >
              <div className="w-10 h-10 bg-yellow-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">E</span>
              </div>
              <span className="text-2xl font-bold text-gray-900">
                Educential
              </span>
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavigation(item.id)}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                  isActive(item.id)
                    ? 'bg-yellow-50 text-yellow-600'
                    : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-3">
            <button
              onClick={() => handleNavigation('login')}
              className="px-5 py-2.5 text-gray-700 font-medium hover:text-gray-900 transition-colors duration-200"
            >
              Sign In
            </button>
            <button
              onClick={() => handleNavigation('signup')}
              className="px-5 py-2.5 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-lg transition-all duration-200 shadow-sm hover:shadow-md"
            >
              Get Started
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 text-gray-700 hover:text-gray-900 transition-colors duration-200"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4 animate-slide-down">
            <div className="flex flex-col space-y-1">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavigation(item.id)}
                  className={`px-4 py-3 text-left rounded-lg font-medium transition-colors duration-200 ${
                    isActive(item.id)
                      ? 'bg-yellow-50 text-yellow-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {item.label}
                </button>
              ))}

              <div className="pt-4 mt-4 border-t border-gray-200 space-y-2">
                <button
                  onClick={() => handleNavigation('login')}
                  className="w-full px-4 py-3 text-center text-gray-700 font-medium hover:bg-gray-50 rounded-lg transition-colors duration-200"
                >
                  Sign In
                </button>
                <button
                  onClick={() => handleNavigation('signup')}
                  className="w-full px-4 py-3 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-lg transition-all duration-200"
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
